module.exports = __webpack_public_path__ + "img/banner-left.a197e2ea.png";